import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-bidding-title',
    templateUrl: './bidding-title.component.html',
    standalone: false
})
export class BiddingTitleComponent {

    @Input() auction: any;

}
